module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/q3@2x_80669f3c0849dede19b5f80819571e98.png";